export default __webpack_public_path__ + "static/media/tailwind.ff4327ea.png";